import qs from 'qs';
import { api } from '@/api/common/instances';

const state = () => ({
  alertUsers: null,
  // BEGIN::Removed.by.KWShin.2026.04.22.
  // kpiThresholds: null,
  // FINISH::Removed.by.KWShin.2026.04.22.
  updateStatus: null,
  updateUsers: null,
  whitelistTypes: null,
  teskTypes: null,
  whitelist: null,
  addWhitelist: null,
  updateWhitelist: null,
  daleteWhitelist: null,
  abapDumpList: null,
  abapDumpItem: null,
  addDumpStatus: null,
  deleteDumpStatus: null,
  eosData: null,
  updateEosStatus: null,
  // BEGIN::Removed.by.KWShin.2025.11.04.
  // Preference > Alert > Program monitor 화면을
  // Store를 거치지 않고 DB를 직접 조작하도록 수정하여
  // Store에서의 기능이 불필요하게 됨.
  // programMonitors: null,
  // addMonitorsStatus: null,
  // updateMonitorStatus: null,
  // daleteMonitorStatus: null,
  // uploadMonitorStatus: null,
  // FINISH::Removed.by.KWShin.2025.11.04.
});

const getters = {
  _whitelistTypes: state => state.whitelistTypes,
  _teskTypes: state => state.teskTypes,
};

const mutations = {
  initState(state) {
    state.updateStatus = null;
  },
  initUpdateUserState(state) {
    state.updateUsers = null;
  },
  initWhiteListEventVal(state) {
    state.addWhitelist = null;
    state.updateWhitelist = null;
    state.daleteWhitelist = null;
  },
  initDumpEventVal(state) {
    state.addDumpStatus = null;
    state.deleteDumpStatus = null;
  },
  // BEGIN::Removed.by.KWShin.2025.11.04.
  // initMonitorEventVal(state) {
  //   state.addMonitorsStatus = null;
  //   state.updateMonitorStatus = null;
  //   state.daleteMonitorStatus = null;
  //   state.uploadMonitorStatus = null;
  // },
  // FINISH::Removed.by.KWShin.2025.11.04.
  whitelistTypes(state, types) {
    state.whitelistTypes = types;
  },
  taskTypes(state, types) {
    state.teskTypes = types;
  },
  alertUsers(state, users) {
    state.alertUsers = users;
  },
  updateAlertUsers(state) {
    state.updateUsers = 'success';
  },
  // BEGIN::Removed.by.KWShin.2026.04.22.
  // kpiThreshold(state, list) {
  //   state.kpiThresholds = list;
  // },
  // updateKpiThreshold(state) {
  //   state.updateStatus = 'success';
  // },
  // FINISH::Removed.by.KWShin.2026.04.22.
  whitelist(state, list) {
    state.whitelist = list;
  },
  addWhitelist(state) {
    state.addWhitelist = 'success';
  },
  updateWhitelist(state) {
    state.updateWhitelist = 'success';
  },
  deleteWhitelist(state) {
    state.daleteWhitelist = 'success';
  },
  abapDumps(state, list) {
    state.abapDumpList = list;
  },
  abapDump(state, item) {
    state.abapDumpItem = item;
  },
  addAbapDump(state, val) {
    state.addDumpStatus = val;
  },
  deleteAbapDump(state, val) {
    state.deleteDumpStatus = val;
  },
  alertEos(state, list) {
    state.eosData = list;
  },
  updateEos(state, val) {
    state.updateEosStatus = val;
  },
  // BEGIN::Removed.by.KWShin.2025.11.04.
  // monitors(state, list) {
  //   state.programMonitors = list;
  // },
  // addMonitors(state, val) {
  //   state.addMonitorsStatus = val;
  // },
  // updateMonitors(state, val) {
  //   state.updateMonitorStatus = val;
  // },
  // deleteMonitors(state, val) {
  //   state.daleteMonitorStatus = val;
  // },
  // addMonitorsAll(state, val) {
  //   state.uploadMonitorStatus = val;
  // },
  // FINISH::Removed.by.KWShin.2025.11.04.
};

const actions = {
  initState({ commit }) {
    commit('initState');
  },
  initUpdateUserState({ commit }) {
    commit('initUpdateUserState');
  },
  initWhiteListEventVal({ commit }) {
    commit('initWhiteListEventVal');
  },
  initDumpEventVal({ commit }) {
    commit('initDumpEventVal');
  },
  initMonitorEventVal({ commit }) {
    commit('initMonitorEventVal');
  },
  async whitelistTypes({ commit }) {
    const { data } = await api.get('/alert-whitelist-types');
    commit('whitelistTypes', data);
  },
  async taskTypes({ commit }) {
    const { data } = await api.get('/statistics/task-types');
    commit('taskTypes', data);
  },
  /**
   * BEGIN::Commented.by.KWShin.2025.12.22.
   * 고객사에서 배치잡의 명칭에 '[', ']' 문자를 넣어놓는 경우가 있어
   * (square bracket은 AXIOS가 배열 기호로 판단하여 URL encoding을 하지 않고
   *  서버는 encoding되지 않은 square bracket을 받으면 RFC 3986 표준 위반으포 판단하여
   *  bad request 400 에러를 낸다)
   * QS 라이브러리를 이용하여 paramsSerializer를 설정하여
   * AXIOS가 square bracket을 encoding하도록 한다.
   * FINISH::Commented.by.KWShin.2025.12.22.
   */
  async alertUsers({ commit }, userInfos) {
    if (!userInfos) return;
    const params = {
      systemId: userInfos.systemId,
      sapDataCode: userInfos.sapDataCode,
      alertCode: userInfos.alertCode,
    };
    const { data } = await api.get('/preference/alert-users', {
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'brackets' });
      },
    });
    commit('alertUsers', data);
  },
  async updateAlertUsers({ dispatch, commit }, userInfos) {
    if (!userInfos) return;
    await dispatch('initUpdateUserState');
    const { sapDataCode, systemId, alertCode } = userInfos;
    const { status } = await api.put('/preference/alert-users', JSON.parse(JSON.stringify(userInfos)));
    if (status === 200) {
      await commit('updateAlertUsers');
      dispatch('alertUsers', { sapDataCode, systemId, alertCode });
    }
  },
  // BEGIN::Removed.by.KWShin.2026.04.22.
  // async kpiThreshold({ commit }, kpiInfos) {
  //   if (!kpiInfos) return;
  //   const { data } = await api.get(`/preference/alert-codes?stackType=${kpiInfos.stackType}&systemId=${kpiInfos.id}`);
  //   data.sort((a, b) => a.message.localeCompare(b.message));
  //   commit('kpiThreshold', data);
  // },
  // async updateKpiThreshold({ dispatch, commit }, kpiInfos) {
  //   const { stackType, systemId: id } = kpiInfos;
  //   await dispatch('initState');
  //   const { status } = await api.put(`/preference/alert-codes`, JSON.parse(JSON.stringify(kpiInfos)));
  //   if (status === 200) {
  //     await commit('updateKpiThreshold');
  //     dispatch('kpiThreshold', { stackType, id });
  //   }
  // },
  // FINISH::Removed.by.KWShin.2026.04.22.
  async whitelist({ commit }, listInfos) {
    if (!listInfos) return;
    const { data } = await api.get(`/preference/alert-whitelist?systemId=${listInfos.systemId}`);
    commit('whitelist', data);
  },
  async addWhitelist({ dispatch, commit }, listInfos) {
    if (!listInfos) return;
    await dispatch('initWhiteListEventVal');
    const { status } = await api.post('/preference/alert-whitelist', JSON.parse(JSON.stringify(listInfos)));
    if (status === 200) {
      await commit('addWhitelist');
      dispatch('whitelist', { systemId: listInfos.systemId });
    }
  },
  async updateWhitelist({ dispatch, commit }, listInfos) {
    if (!listInfos) return;
    await dispatch('initWhiteListEventVal');
    const { status } = await api.put('/preference/alert-whitelist', JSON.parse(JSON.stringify(listInfos)));
    if (status === 200) {
      await commit('updateWhitelist');
      dispatch('whitelist', { systemId: listInfos.systemId });
    }
  },
  async deleteWhitelist({ dispatch, commit }, listInfos) {
    if (!listInfos) return;
    let data = {
      sequence: listInfos.sequence,
    };
    const { systemId } = listInfos;
    const { status } = await api.delete('/preference/alert-whitelist', JSON.parse(JSON.stringify({ data })));
    if (status === 200) {
      await commit('deleteWhitelist');
      dispatch('whitelist', { systemId: systemId });
    }
  },
  async abapDumps({ commit }) {
    const { data } = await api.get('/preference/abap-dumps');
    commit('abapDumps', data);
  },
  async abapDump({ commit }, dumpInfos) {
    if (!dumpInfos) return;
    const { data } = await api.get(`/preference/abap-dumps/${dumpInfos.systemId}/${dumpInfos.category}`);
    commit('abapDump', data);
  },
  async addAbapDump({ dispatch, commit }, dumpInfos) {
    if (!dumpInfos) return;
    await dispatch('initDumpEventVal');
    const { status } = await api.post(`/preference/abap-dumps/${dumpInfos.systemId}/${dumpInfos.alertCode}`);
    if (status === 200) {
      commit('addAbapDump', 'success');
    } else {
      commit('addAbapDump', 'error');
    }
  },
  async deleteAbapDump({ dispatch, commit }, dumpInfos) {
    if (!dumpInfos) return;
    await dispatch('initDumpEventVal');
    const { status } = await api.delete(`/preference/abap-dumps/${dumpInfos.systemId}/${dumpInfos.alertCode}`);
    if (status === 200) {
      commit('deleteAbapDump', 'success');
    } else {
      commit('deleteAbapDump', 'error');
    }
  },
  async alertEos({ commit }) {
    const { data } = await api.get('/preference/alert-eos');
    commit('alertEos', data);
  },
  async updateEos({ commit }, eosInfos) {
    if (!eosInfos) return;
    await commit('updateEos', null);
    const { status } = await api.put('/preference/alert-eos', JSON.parse(JSON.stringify(eosInfos)));
    if (status === 200) {
      await commit('updateEos', 'success');
    } else {
      commit('updateEos', 'error');
    }
  },
  // BEGIN::Removed.by.KWShin.2025.11.04.
  // async monitors({ commit }, programInfos) {
  //   if (!programInfos) return;
  //   const { data } = await api.get(`/preference/program-monitors/${programInfos.systemId}`);
  //   commit('monitors', data);
  // },
  // async addMonitors({ dispatch, commit }, programInfos) {
  //   if (!programInfos) return;
  //   await dispatch('initMonitorEventVal');
  //   console.log('in store common alert, programInfos=', programInfos);
  //   const { status } = await api.post('/preference/program-monitors', JSON.parse(JSON.stringify(programInfos)));
  //   if (status === 200) {
  //     await commit('addMonitors', 'success');
  //     dispatch('monitors', programInfos);
  //   } else {
  //     commit('addMonitors', 'error');
  //   }
  // },
  // async updateMonitors({ dispatch, commit }, programInfos) {
  //   if (!programInfos) return;
  //   await dispatch('initMonitorEventVal');
  //   const { status } = await api.put('/preference/program-monitors', JSON.parse(JSON.stringify(programInfos)));
  //   if (status === 200) {
  //     await commit('updateMonitors', 'success');
  //     dispatch('monitors', programInfos);
  //   } else {
  //     commit('updateMonitors', 'error');
  //   }
  // },
  // async deleteMonitors({ dispatch, commit }, data) {
  //   if (!data) return;
  //   await dispatch('initMonitorEventVal');
  //   const { status } = await api.delete('/preference/program-monitors', JSON.parse(JSON.stringify({ data })));
  //   if (status === 200) {
  //     commit('deleteMonitors', 'success');
  //     dispatch('monitors', data);
  //   } else {
  //     commit('deleteMonitors', 'error');
  //   }
  // },
  // async addMonitorsAll({ dispatch, commit }, programInfos) {
  //   if (!programInfos) return;
  //   const { formData } = programInfos;
  //   const { infos } = programInfos;
  //   await dispatch('initMonitorEventVal');
  //   const { status } = await api.post('/preference/program-monitors-all', formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   });
  //   if (status === 200) {
  //     await commit('addMonitorsAll', 'success');
  //     dispatch('monitors', infos);
  //   } else {
  //     commit('addMonitorsAll', 'error');
  //   }
  // },
  // FINISH::Removed.by.KWShin.2025.11.04.
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
